import React from 'react'
import { Form } from 'react-bootstrap'

const Wrapper = ({ children  }) => (
    <Form.Group>
        <Form.Label>Participants</Form.Label>
        <div
            style={{
                border: '1px solid rgb(206, 212, 218)',
                borderRadius: '4px',
                minHeight: '38px'
            }}
        >
            {children}
        </div>
    </Form.Group>
)

export default Wrapper